import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { FAQS } from './salesData';

/** Preguntas frecuentes en acordeón. */
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="w-full border-b border-line bg-carbon" data-id="element-50" data-mp="1gjc0fofmch2q">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-51" data-mp="1glpupv2h5p98">
        <SectionTag data-id="element-52" data-mp="24aheby200zae">Preguntas frecuentes</SectionTag>
        <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-53" data-mp="28ajjih6y0auf">
          Todo lo que querés saber antes de comprar
        </h2>

        <ul className="mt-9 divide-y divide-line border-y border-line" data-id="element-54" data-mp="1uhabokyn7xe0">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} data-id="element-55" data-mp="2n6hc5phnqx1w" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-5 text-left transition-colors duration-150 ease-out hover:text-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-56" data-mp="2n67hvppky3qe">
                  <span className="font-display text-[0.98rem] leading-snug text-bone" data-id="element-57" data-mp="1emy8cd4254ap">
                    {faq.q}
                  </span>
                  <span className="mt-0.5 shrink-0 text-gold" aria-hidden data-id="element-58" data-mp="1oihzynbl9gtn">
                    {isOpen ? <MinusIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-59" data-mp="1jj55bgeh75gi" /> : <PlusIcon className="h-5 w-5" strokeWidth={2.5} data-id="element-60" data-mp="1xiwp5xrobg2f" />}
                  </span>
                </button>
                {isOpen && <p className="-mt-1 pb-5 pr-8 text-[0.93rem] leading-relaxed text-ash" data-id="element-61" data-mp="35ose0k50ue5">{faq.a}</p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}